import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const SMTPSettingsSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();

  const required = t('common.formErrorMessages.required');
  const fromEmail = t('common.formErrorMessages.from_email');
  const portType = t('common.formErrorMessages.port_type');
  const noWhitespaces = t('common.formErrorMessages.no_whitespaces');

  return yup.object({
    fromEmail: yup
      .string()
      .matches(/^\S*$/, noWhitespaces)
      .email(fromEmail)
      .required(required),
    fromName: yup.string(),
    username: yup.string().matches(/^\S*$/, noWhitespaces).required(required),
    hostname: yup.string().matches(/^\S*$/, noWhitespaces).required(required),
    password: yup.string().matches(/^\S*$/, noWhitespaces).required(required),
    port: yup.number().typeError(portType).required(required),
    sendBcc: yup.boolean(),
  });
};
